export default __webpack_public_path__ + "static/media/ln_kr.da5406ce.jpg";